import { cn } from '@/shared/cn';

type ToggleSwitchProps = {
  id: string;
  checked: boolean;
  onCheckedChange: (next: boolean) => void;
  disabled?: boolean;
  'aria-describedby'?: string;
};

/** Radix-free switch matching ai-foundation class strings. */
export function ToggleSwitch({
  id,
  checked,
  onCheckedChange,
  disabled,
  'aria-describedby': ariaDescribedBy,
}: ToggleSwitchProps) {
  return (
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={checked}
      aria-describedby={ariaDescribedBy}
      disabled={disabled}
      onClick={() => onCheckedChange(!checked)}
      className={cn(
        'relative mt-1 h-5 w-9 flex-shrink-0 cursor-pointer rounded-full bg-zinc-200 transition-colors disabled:cursor-not-allowed disabled:opacity-50 dark:bg-zinc-700',
        checked && 'bg-accent-500 dark:bg-accent-500',
      )}
    >
      <span
        className={cn(
          'block h-4 w-4 translate-x-0.5 rounded-full bg-white shadow-sm transition-transform',
          checked && 'translate-x-[18px]',
        )}
      />
    </button>
  );
}
